import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import {
    CreatePackingListCartonRequest,
    CreatePackingListRequest,
    PackingListCartonDTO,
    PackingListDTO,
    PageResponse,
    UpdatePackingListCartonRequest,
    UpdatePackingListRequest,
} from '../interfaces/commercial.interface';

/** Packing list (15.2) — header + carton child lines, roll-ups computed server-side. Returns data
 * only — components own triggerDownload/showApiError per house rules (mirrors exportLc.service). */
export const PackingListService = {
    list: async (institutionId: string, page = 0, size = 20): Promise<PageResponse<PackingListDTO>> =>
        (await axios.get(`${ENDPOINTS.PACKING_LIST.LIST(institutionId)}?page=${page}&size=${size}`)).data,
    getById: async (institutionId: string, id: string): Promise<PackingListDTO> =>
        (await axios.get(ENDPOINTS.PACKING_LIST.GET_BY_ID(institutionId, id))).data,
    create: async (institutionId: string, dto: CreatePackingListRequest): Promise<PackingListDTO> =>
        (await axios.post(ENDPOINTS.PACKING_LIST.CREATE(institutionId), dto)).data,
    update: async (institutionId: string, id: string, dto: UpdatePackingListRequest): Promise<PackingListDTO> =>
        (await axios.put(ENDPOINTS.PACKING_LIST.UPDATE(institutionId, id), dto)).data,
    remove: async (institutionId: string, id: string): Promise<void> => {
        await axios.delete(ENDPOINTS.PACKING_LIST.DELETE(institutionId, id));
    },

    // ---- carton child lines -------------------------------------------------------------------
    listCartons: async (institutionId: string, id: string): Promise<PackingListCartonDTO[]> =>
        (await axios.get(ENDPOINTS.PACKING_LIST.CARTONS(institutionId, id))).data,
    createCarton: async (
        institutionId: string, id: string, dto: CreatePackingListCartonRequest,
    ): Promise<PackingListCartonDTO> =>
        (await axios.post(ENDPOINTS.PACKING_LIST.CARTONS(institutionId, id), dto)).data,
    updateCarton: async (
        institutionId: string, id: string, cartonId: string, dto: UpdatePackingListCartonRequest,
    ): Promise<PackingListCartonDTO> =>
        (await axios.put(ENDPOINTS.PACKING_LIST.CARTON(institutionId, id, cartonId), dto)).data,
    removeCarton: async (institutionId: string, id: string, cartonId: string): Promise<void> => {
        await axios.delete(ENDPOINTS.PACKING_LIST.CARTON(institutionId, id, cartonId));
    },

    // ---- pdf ------------------------------------------------------------------------------------
    downloadPackingListPdf: async (institutionId: string, id: string): Promise<Blob> =>
        (await axios.get(ENDPOINTS.PACKING_LIST.PDF(institutionId, id), { responseType: 'blob' })).data,
};
